import { useState } from 'react'

import { SearchInput } from '@/pages/MesperyIM/components/SearchInput'
import { useMessageAtom } from '@/pages/MesperyIM/store/message'
import { isClickInsideElement } from '@/utils'
import {
  handleClickCreateGroupChat,
  handleClickGroupList,
  handleClickMessageList
} from '@/utils/trackSensors'
import DelSrc from '@img/components/close.png'
import Plus from '@img/message/plus.png'

import { Contacts } from './Contacts'
import { Groups } from './Groups'
import { Messages } from './Messages'
import styles from '../message.module.less'
import { EConversationType } from '../types/message'

enum ContactEnum {
  Message = 'message',
  Group = 'group',
  Contact = 'contact'
}

export const getDefaultNickName = (type: EConversationType) => {
  if (type === EConversationType.PRIVATE) {
    return 'Non-Mutual Follow'
  }

  if (type === EConversationType.GROUP) {
    return 'Left Group'
  }

  return ''
}

export const ContactsModal = () => {
  const {
    toggleMessageModalVisible,
    messageModalVisible,
    setCreateCroup,
    setPersonalGrouping,
    setGroupManage,
    groupManageVisible,
    searchKeyword,
    setSearchKeyword
  } = useMessageAtom()

  const [tab, setTab] = useState<ContactEnum>(ContactEnum.Message)

  const onClickPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    const targetElement = document.getElementById('groupManageEle')
    if (targetElement && isClickInsideElement(targetElement, event)) {
      console.log('点击发生在目标元素内部')
      return
    } else if (groupManageVisible) {
      setGroupManage(false)
    }
  }

  return (
    <>
      <div
        className={`${styles.contactsModal} ${
          messageModalVisible ? styles.contactsModalShow : ''
        }`}
        onClick={onClickPanel}
      >
        {/* 关闭弹窗 */}
        <a className="btn-del" onClick={() => toggleMessageModalVisible(false)}>
          <img src={DelSrc} width={46} />
        </a>

        {/* 搜索&添加 */}
        <div className="top-actions flx-justify-between">
          <SearchInput
            value={searchKeyword}
            onChange={(e) => {
              setSearchKeyword(e.target.value)
            }}
          />
          {tab === ContactEnum.Group && (
            <button
              className="g-btn g-btn-ghost"
              onClick={() => {
                handleClickCreateGroupChat()
                setCreateCroup(true)
                setPersonalGrouping(true)
              }}
            >
              <img src={Plus} width={13} />
            </button>
          )}
        </div>

        {/* tab */}
        <ul className="tabs">
          <li
            className={
              tab === ContactEnum.Message ? 'message active' : 'message'
            }
            onClick={() => {
              handleClickMessageList()
              setTab(ContactEnum.Message)
            }}
          >
            <i />
          </li>
          <li
            className={tab === ContactEnum.Group ? 'group active' : 'group'}
            onClick={() => {
              handleClickGroupList()
              setTab(ContactEnum.Group)
            }}
          >
            <i />
          </li>
        </ul>

        {/* 聊天 */}
        <Messages
          rootStyle={{
            display: tab === ContactEnum.Message ? 'block' : 'none'
          }}
        />

        {/* 群组 */}
        <Groups
          rootStyle={{
            display: tab === ContactEnum.Group ? 'block' : 'none'
          }}
        />

        {/* 通讯录 */}
        {/* {tab === ContactEnum.Contact && <Contacts />} */}
      </div>
    </>
  )
}
